<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat class="card-border">
          <h2>Кассиры</h2>
          <div class="mx-3">
          </div>
          <v-dialog
            v-model="addDialog"
            persistent :overlay="false"
            max-width="500px"
            transition="dialog-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" color="primary">Новый кассир</v-btn>
            </template>
            <v-card>
              <v-card-title primary-title>
                Новый кассир
              </v-card-title>
              <v-card-text>
                <v-text-field
                  name="cardid"
                  label="Номер карты кассира"
                  v-model="cardid"
                ></v-text-field>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" :disabled="!cardid || cardid.length !== 9" @click="addCashier">Добавить кассира</v-btn>
                  <v-btn text @click="close">Отмена</v-btn>
                </v-card-actions>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-spacer></v-spacer>
          <v-checkbox
            label="Без заблокированных"
            v-model="withoutBlocked"
            hide-details
            ></v-checkbox>
          <v-spacer></v-spacer>
          <v-text-field
          v-model="search"
          append-icon="search"
          label="Поиск"
          single-line
          hide-details
          clearable
          style="max-width: 400px"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          no-data="пусто" no-data-text="пусто" no-results-text="ничего не найдено"
          :items-per-page="-1"
          :headers="headers"
          :items="cashiers || []"
          :search="search"
          hide-default-footer
          dense
          class="card-border"
        >
          <template v-slot:item.cts="{ item }">
            {{ dateFormat(item.cts) }}
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn
              v-if="item.blocked === false"
              small color="red" text
              @click="blockCashier(item)"
            >
              Заблокировать
            </v-btn>
            <v-btn
              v-else
              small color="green" text
              @click="unblockCashier(item)"
            >
              Разблокировать
            </v-btn>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'

export default {
  name: 'cashiers',
  data: () => ({
    cashiers: null,
    search: '',
    headers: [
      { text: 'карта', value: 'cardid' },
      { text: 'имя', value: 'fullname' },
      { text: 'дата добавления', value: 'cts' },
      { text: 'действия', value: 'action' }
    ],
    // add new cashier
    cardid: null,
    addDialog: false,
    withoutBlocked: true
  }),
  computed: {
    profile () {
      return this.$store.state.profile
    }
  },
  methods: {
    async fetch () {
      try {
        const { cashiers } = await this.$store.dispatch('sioRequest', {
          topic: 'org-cashiers'
        })
        if (this.withoutBlocked) {
          this.cashiers = cashiers.filter(x => x.blocked === false)
        } else {
          this.cashiers = cashiers
        }
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async addCashier () {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'org-cashiers-add',
          pl: {
            cardid: this.cardid
          }
        })
        this.$store.dispatch('snack', meta.msg)
      } catch (err) {
        this.$store.dispatch('snack', err)
      } finally {
        this.close()
        this.fetch()
      }
    },
    async blockCashier (cashier) {
      try {
        await this.$store.dispatch('confirm', `ЗАБЛОКИРОВАТЬ кассира ${cashier.fullname}?`)
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'org-cashiers-block',
          pl: cashier
        })
        this.$store.dispatch('snack', meta.msg)
      } catch (err) {
        this.$store.dispatch('snack', err)
      } finally {
        this.close()
        this.fetch()
      }
    },
    async unblockCashier (cashier) {
      try {
        await this.$store.dispatch('confirm', `РАЗБЛОКИРОВАТЬ кассира ${cashier.fullname}?`)
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'org-cashiers-unblock',
          pl: cashier
        })
        this.$store.dispatch('snack', meta.msg)
      } catch (err) {
        this.$store.dispatch('snack', err)
      } finally {
        this.close()
        this.fetch()
      }
    },
    close () {
      this.cardid = null
      this.addDialog = false
    },
    dateFormat (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    },
    withoutBlocked (val) {
      this.fetch()
    }
  },
  async mounted () {
    if (this.profile) await this.fetch()
  }
}
</script>
